import React, { FC, Suspense } from 'react';

interface RouterSuspenseProps {
  children: React.ReactNode;
}

export const RouterSuspense: FC<RouterSuspenseProps> = (props) => {
  const { children } = props;
  return <Suspense fallback={<></>}>{children}</Suspense>;
};
